import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators, RequiredValidator } from '@angular/forms';
import { Router } from '@angular/router';
import { RptFillAlllDDlserviceService } from 'src/app/Shared/Services/rpt-fill-alll-ddlservice.service';
import { ToastrService } from 'ngx-toastr';
import * as Global from '../../../Shared/Model/CommanHttp';

declare var $: any;

@Component({
  selector: 'app-rpt-payment-detail',
  templateUrl: './rpt-payment-detail.component.html',
  styleUrls: ['./rpt-payment-detail.component.css']
})
export class RptPaymentDetailComponent implements OnInit {

  FrmRptPaymentDetail: FormGroup; ddlAuctionTypeList: any = [];
  FromDate: any; ToDate: any;


  constructor(private fb: FormBuilder, private MsgService: ToastrService, private router: Router,
    private RptFillAlllDDlService: RptFillAlllDDlserviceService) { }
  ngOnInit() {
    this.CreateFrmRptAuction();
    this.FillAllDDL();
    // this.formValues['type'] = "2";
  }
  CreateFrmRptAuction() {
    this.FrmRptPaymentDetail = this.fb.group({
      ddlPayment: ['0'],
      ddlAuctionType: ['0'],
      txtDateFrom: ['', [Validators.maxLength(10), Validators.minLength(10)]],
      txtDateTo: ['', [Validators.maxLength(10), Validators.minLength(10)]],
    })
  }
  FillAllDDL() {
    let Ind = 1;
    let ResponseDecrpt = sessionStorage.getItem('loginSession');
    let loginlist = JSON.parse(window.atob(ResponseDecrpt));
    let OrgCode = loginlist[0]['OrgCode'];
    let CityCode = loginlist[0]['CityCode'];
    this.RptFillAlllDDlService.FillAllddl(Ind, OrgCode, CityCode).subscribe(respdata => {


      if (respdata != "" && respdata.SuccessCD == 1) {
        if (respdata.RespData.Table.length > 0) {

          this.ddlAuctionTypeList = respdata.RespData.Table2

        }
      }
      else {
        if (respdata != "" && respdata.SuccessCD == 0) {
          this.MsgService.warning(respdata.MsgDesc);
        }
        else { this.MsgService.error('Not Found'); }
      }




    })
  }
  AuctionTypeTextval: any = "";
  onChange(event) {
    this.AuctionTypeTextval = "";;
    this.AuctionTypeTextval = event.source.selected.viewValue == null ? "" : event.source.selected.viewValue;
  }
  OnAuctionPreview() {

    let AuctionType = this.FrmRptPaymentDetail.controls['ddlAuctionType'].value;
    // let AuctionType1 = this.FrmRptPaymentDetail[index]);
    // console.log(this.familyRelationArray[index].family_relation_type);


    let ReportTypeInd = this.FrmRptPaymentDetail.controls['ddlPayment'].value;
    if (ReportTypeInd != 1 && ReportTypeInd != 2 || ReportTypeInd != 3) {
      ReportTypeInd = 0;
    }
    let ResponseDecrpt = sessionStorage.getItem('loginSession');
    let loginlist = JSON.parse(window.atob(ResponseDecrpt));
    let OrgCode = loginlist[0]['OrgCode'];
    let CityCode = loginlist[0]['CityCode'];
    this.FromDate = this.FrmRptPaymentDetail.controls['txtDateFrom'].value;
    this.ToDate = this.FrmRptPaymentDetail.controls['txtDateTo'].value;
    if (this.FromDate == '') {
      {
        this.MsgService.error("Please select the from Date");
        return false;
      }
    }
    if (this.ToDate == '') {
      {
        this.MsgService.error("Please select the To Date ");
        return false;
      }
    }
    if (this.FromDate != '' && this.ToDate != '') {
      if (this.FrmRptPaymentDetail.controls['txtDateFrom'].value > this.FrmRptPaymentDetail.controls['txtDateTo'].value) {
        this.MsgService.error("From Date cannot be  greater than  To ");
        return false;
      }
    }


    var res = $('#txtDateFr').val().split('/');
    this.FromDate = res[2] + '/' + res[1] + '/' + res[0];

    var restodt = $('#txtDateToo').val().split('/');
    this.ToDate = restodt[2] + '/' + restodt[1] + '/' + restodt[0];
    //  let Heading = 'Jaipur Municiple Corporation';
    let Heading = loginlist[0]['ReportHeading'];
    let ReportHeading = this.AuctionTypeTextval + '  Payment Detail Report';

    // window.open(`http://localhost:58298/RptPaymentDetail.aspx?Ind=1&OrgCode=` + OrgCode + `&CityCode=` + CityCode + `&AuctionNo=` + 0 + `&ReportTypeInd=` + ReportTypeInd + `&AuctionTypecd=` + AuctionType + `&DateFrom=` + this.FromDate + `&DateTo=` + this.ToDate + `&ReportHeading=` + ReportHeading + `&Heading=` + Heading + `&ReportName=RptPaymentDetail`);
    // window.open(`http://115.124.113.64/JMCEAuctionReportSource/RptAuctionParticipation.aspx?Ind=1&OrgCode=` + OrgCode + `&CityCode=` + CityCode + `&AuctionNo=` + AuctionNo + `&AuctionTypecd=` + AuctionType + `&ActiveInd=` + Status +`&Zone=` + Zone +`&DateFrom=` + this.FromDate + `&DateTo=` + this.ToDate +`&ReportHeading=` + ReportHeading + `&Heading=` + Heading + `&ReportName=RptAuctionParticipation`);
    window.open(`http://oswalapp.centralindia.cloudapp.azure.com/JMCEAuctionReportViewerSource/RptPaymentDetail.aspx?Ind=1&OrgCode=` + OrgCode + `&CityCode=` + CityCode + `&AuctionNo=` + 0 + `&ReportTypeInd=` + ReportTypeInd + `&AuctionTypecd=` + AuctionType + `&DateFrom=` + this.FromDate + `&DateTo=` + this.ToDate + `&ReportHeading=` + ReportHeading + `&Heading=` + Heading + `&ReportName=RptPaymentDetail`);


  }

  OnClear() {

    this.FrmRptPaymentDetail.controls['ddlPayment'].setValue('0');
    this.FrmRptPaymentDetail.controls['ddlAuctionType'].setValue('0');
    this.FrmRptPaymentDetail.controls['txtDateFrom'].setValue('');
    this.FrmRptPaymentDetail.controls['txtDateTo'].setValue('');

  }

}


